import { browserHistory, createMemoryHistory } from 'react-router';
import { createMemoryHistory as createMemoryHistoryRouterV4 } from 'history';

/**
 * Provides an environment appropriate history management object for react-router
 */
export const getHistory = (routerConfig = {}) => {
    const hasBrowserHistory =
        typeof browserHistory !== 'undefined' &&
        process.env.NODE_ENV !== 'test';

    let _browserHistory;

    if (hasBrowserHistory) {
        _browserHistory = browserHistory;
    } else if (routerConfig.isRouterV4) {
        _browserHistory = createMemoryHistoryRouterV4();
    } else {
        _browserHistory = createMemoryHistory();
    }

    return _browserHistory;
};
